/**
 * Progress bar for the Custom multicolumn mobile carousel.
 *
 * The scrolling itself is native CSS scroll-snap. This only mirrors the
 * scroll position into a thumb, and hides the track when there is nothing
 * to scroll (desktop, or fewer columns than fit).
 */
class CmcCarousel extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.cmc__list');
    this.progress = this.querySelector('.cmc__progress');
    this.thumb = this.querySelector('.cmc__progress-thumb');

    if (!this.list || !this.progress || !this.thumb) return;

    this.update = this.update.bind(this);
    this.list.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.list);
    }

    this.update();
  }

  disconnectedCallback() {
    if (this.list) this.list.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
    if (this.observer) this.observer.disconnect();
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.list;
    const scrollable = scrollWidth - clientWidth;

    // Nothing to scroll: hide the track rather than show a full-width thumb.
    this.progress.hidden = scrollable <= 1;
    if (this.progress.hidden) return;

    this.thumb.style.width = `${(clientWidth / scrollWidth) * 100}%`;
    this.thumb.style.left = `${(scrollLeft / scrollWidth) * 100}%`;
  }
}

if (!customElements.get('cmc-carousel')) {
  customElements.define('cmc-carousel', CmcCarousel);
}
